import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import QuotationGrid from "../../compenents/Quotation/QuotationGrid";

interface QuotationsProps {}

const Quotations: React.FunctionComponent<QuotationsProps> = (props) => {
  return (
    <>
      <Container maxWidth={false}>
        <Grid item xs={4}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
            Leads
          </Typography>
        </Grid>
        <QuotationGrid></QuotationGrid>
      </Container>
    </>
  );
};

export default Quotations;
